export default __webpack_public_path__ + "static/media/Project-5-SingleProject-MobileDisplay.5b9bcd58.png";